import { Fragment } from "react";
import { Card, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import useSharedData from "../../../../hooks/useSharedData";
import Footer from "../../../public/footer/footer";
import Menu from "../../../public/menu/menu";
import ComplainForm from "../../myAccount/account/ComplainForm";

function ContentComplain() {
  const { isAuthed } = useSharedData();

  return (
    <Fragment>
      <Menu />

      <Container className="mt-5 loginContainer">
        <h2>شکایات و انتقادات</h2>

        <Row xl={1} lg={1} md={1} xs={1} className="mt-4">
          <p>
            <span>لطفا برای رهگیری مرسوله و سایر خدمات،</span>
            {!isAuthed && <span> ابتدا ورود کرده سپس</span>}
            <span> فرم دیگری </span>
            <Link to="/support" className="text-decoration-underline">
              (تیکت) را تکمیل کنید
            </Link>
          </p>

          <div className="loginFormCol mt-2">
            <Card className="loginForm">
              <ComplainForm />
            </Card>
          </div>
        </Row>
      </Container>

      <Footer />
    </Fragment>
  );
}

export default ContentComplain;
